import * as React from "react";
const SvgFiRrSmoking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 16H2.5A2.503 2.503 0 0 0 0 18.5v1C0 20.879 1.122 22 2.5 22H19a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1M2 19.5v-1a.5.5 0 0 1 .5-.5H7v2H2.5a.5.5 0 0 1-.5-.5m16 .5H9v-2h9zm6-3v4a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0m-4-5.18V13a1 1 0 1 1-2 0v-1.18c0-.698-.372-1.356-.972-1.716l-1.601-.961A5.02 5.02 0 0 1 13 4.856V3a1 1 0 1 1 2 0v1.856c0 1.048.558 2.033 1.457 2.572l1.602.961A4.02 4.02 0 0 1 20 11.82m4-1.556v.735a1 1 0 1 1-2 0v-.735a3.01 3.01 0 0 0-1.457-2.572L18.456 6.44a3.02 3.02 0 0 1-1.457-2.573V1a1 1 0 1 1 2 0v2.867c0 .35.187.679.486.858l2.086 1.252a5.02 5.02 0 0 1 2.427 4.287z"
    />
  </svg>
);
export default SvgFiRrSmoking;
